module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_05_1280_1280_th-2e61afa31d365546fe58baa6525d3c6f.jpg";